import {
	Component,
	ViewChild,
	TemplateRef
} from '@angular/core';
import {
	NgbModal,
} from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../services/authentication.service';
import { HttpClient } from '@angular/common/http';
import { AlertService } from 'ngx-alerts';
import { urls, errorMessages } from '../../../assets/constants.json';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
	selector: 'app-profile',
	templateUrl: './profile.component.html',
	styleUrls: ['./profile.component.scss']
})

export class ProfileComponent {
	@ViewChild('passwordModalContent') private passwordModalContent: TemplateRef<any>;

	profile: any;
	passwordForm: FormGroup;

	constructor(private modalService: NgbModal,
		private authService: AuthenticationService,
		private spinner: NgxSpinnerService,
		private http: HttpClient,
		private fb: FormBuilder,
		private alertService: AlertService
	) {
		this.passwordForm = this.fb.group({
			oldPassword: ['', [Validators.required, Validators.minLength(6)]],
			password: ['', [Validators.required, Validators.minLength(6)]],
			confirmPassword: ['', [Validators.required, Validators.minLength(6)]],
		});

		this.getUserInfo();
	}

	logout() {
		this.authService.logout();
	}

	private getUserInfo(): void {
		const userinfo = this.authService.currentUser;
		this.profile = !!userinfo ? userinfo.profile : {};
	}

	openPasswordModal(): void {
		this.passwordForm.setValue({
			oldPassword: '',
			password: '',
			confirmPassword: ''
		});
		this.modalService.open(this.passwordModalContent);
	}

	changeMyPassword(): void {
		this.spinner.show();
		const data = {
			...this.passwordForm.value
		};
		const sub = this.http.put(`${urls.idpBaseUrl}${urls.idp.resetMyPassword}`, data)
			.finally(() => {
				this.spinner.hide();
				sub.unsubscribe();
			}).subscribe(() => {
				this.modalService.dismissAll();
				this.alertService.success('Contraseña cambiada exitosamente.');
			}, (response) => {
				const error = response.error;
				const errorMessage = error.status === 0 ?
					errorMessages.connectionError : !!error.title ? error.title : errorMessages.genericError;
				this.alertService.danger(errorMessage);
			});
	}
}
